import AnimatedNumber from '../components/AnimatedNumber.jsx';
import Icon from '../components/Icon.jsx';
import { marketRows } from '../data.js';

const metricMap = [
  { label: 'Primary catchment population', value: 105000, display: '≈105,000', tone: 'large' },
  { label: 'Schools within 10 km', value: 14, display: '14' },
  { label: 'Estimated students', value: 13000, display: '≈13,000' },
  { label: 'Existing TOH SEHA patients from Dubai & Northern Emirates', value: 40, suffix: '%', display: '40%' },
];

export default function MarketSlide({ active }) {
  return (
    <section className="slide-content market-slide v2-market">
      <div className="v2-market-heading reveal-stack">
        <div className="eyebrow"><Icon name="network" />Market Opportunity</div>
        <h2>Market Opportunity Estimate</h2>
      </div>

      <div className="v2-market-layout">
        <div className="v2-market-board">
          <div className="v2-board-header">
            <span>Market Opportunity</span>
            <span>Estimate</span>
          </div>
          {marketRows.map((row, index) => (
            <div className="v2-board-row" key={row.label}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <b>{row.label}</b>
              <strong>{row.value}</strong>
            </div>
          ))}
        </div>

        <div className="v2-market-metrics">
          {metricMap.map((metric, index) => (
            <article className={`v2-metric-card ${metric.tone === 'large' ? 'is-large' : ''}`} key={metric.label}>
              <div className="v2-metric-index">0{index + 1}</div>
              <small>{metric.label}</small>
              <AnimatedNumber
                value={metric.value}
                suffix={metric.suffix || ''}
                prefix={metric.display.startsWith('≈') ? '≈' : ''}
                active={active}
              />
              <i />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
